import React from "react";
import ReactDOM from "react-dom";
import Button from "./Button.jsx";

export default class Box extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isCheckedAll: false,
    };
    this.isClickBlocked = false;
  }

  onHeaderClick() {
    if (this.isClickBlocked || this.props.clickDisabled) {
      return;
    }

    //Função estava sendo chamada varias vezes ao clicar no cabeçalho
    this.isClickBlocked = true; // Bloqueia cliques futuros
    setTimeout(() => {
      this.isClickBlocked = false; // Desbloqueia após 300ms
    }, 300);

    if (!this.state.isOpen) {
      this.setState({
        isOpen: true
      },
        () => {
          this.props.onToggle(this.props.id);
          ReactDOM.findDOMNode(this.button).click();
        })
    } else if (this.state.isOpen) {
      this.setState({
        isOpen: false
      },
        () => {
          this.props.onToggle(this.props.id);
          ReactDOM.findDOMNode(this.button).click();
        })
    }

  }

  fecharBox = () => {
    if (this.isClickBlocked) {
      return;
    }

    this.isClickBlocked = true;
    setTimeout(() => {
      this.isClickBlocked = false;
    }, 100);
    if (this.state.isOpen) {

      this.setState({
        isOpen: false
      }, () => {

        ReactDOM.findDOMNode(this.button).click();
      })
    }
  };

  onButtonClick(e) {
    e.stopPropagation();
    this.props.onSelectAllCheckboxes()
  }

  render() {
    return (
      <div
        id={this.props.id}
        className={
          "box " +
          (this.props.collapsible && !this.props.openByDefault
            ? "collapsed-box "
            : "") +
          this.props.className
        }
        style={{ maxHeight: "100%", overflow: "hidden" }}
      >
        {/* Cabeçalho caso haja um: */}
        {this.props.title && (
          <div
            className={" box-header hand with-border " + this.props.headerClass}
            onClick={this.onHeaderClick.bind(this)}
          >
            {/* Título */}
            <h3 className="box-title">{this.props.title}</h3>
            {this.props.subtitle ? (
              <span>
                <br /> <h4 className="box-title">{this.props.subtitle}</h4>
              </span>
            ) : null}

            {/* Botão que aparecerá quando o Box estiver aberto: */}
            {this.state.isOpen && (
              <Button
                style={{ marginLeft: "10px" }}
                label="Selecionar Todos"
                className="btn-blue"
                onClick={this.onButtonClick.bind(this)}
              />
            )}

            {/* Icones: */}
            <div className="box-tools pull-right">
              {/* Ícone de minimizar: */}
              {this.props.collapsible && (
                <Button
                  className="btn-box-tool"
                  data-widget="collapse"
                  ref={(e) => (this.button = e)}
                  icon="fa-minus"
                  onClick={this.props.btnOnClick}
                />
              )}
              {this.props.closeable ? (
                <Button
                  className="btn-box-tool"
                  data-widget="remove"
                  ref={(e) => (this.button = e)}
                  icon="fa-times"
                />
              ) : null}
            </div>
          </div>
        )}

        {/* Conteúdo G.O.D: */}
        <div className={"box-body " + this.props.bodyClass}>
          {this.props.children}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/lib_react_adminlte/componentes/Box.jsx